<main class="integrations-container" (click)="closeMenus()">

  <!-- Page header -->
  <div class="integrations-CTA">
    <h1>{{ integrationType === 'api' ? 'API Endpoints' : integrationType === 'cloud' ? 'Cloud Storage' : 'Integrations' }}</h1>
    <h4>{{ integrationType === 'api'
      ? 'Manage shared endpoint configurations for your tenant. All admins can view and use these endpoints.'
      : integrationType === 'cloud'
        ? 'Manage your cloud storage integrations.'
        : 'View and setup your integrations here' }}</h4>
  </div>

  <!-- Navigation cards (landing) -->
  <div class="integration-nav-container" [style.display]="integrationType === '' ? 'flex' : 'none'">
    <div class="integration-option" (click)="navOption('api')">
      <div>
        <span class="option-icon-wrap"><img src="../../assets/gear-icon.svg" alt="api endpoints" /></span>
        <h3>Api Endpoints</h3>
      </div>
      <span class="endpoint-count-pill">{{ activeEndpointCount }} Active Endpoints</span>
    </div>
    <div class="integration-option" (click)="navOption('cloud')">
      <div>
        <span class="option-icon-wrap"><img src="../../assets/cloud-icon.svg" alt="cloud storage" /></span>
        <h3>Cloud Storage</h3>
      </div>
      <span class="endpoint-count-pill">0 Endpoints</span>
    </div>
  </div>

  <!-- API Endpoints table view -->
  <div [style.display]="integrationType === 'api' ? 'block' : 'none'" class="api-section">

    <div class="api-section-header">
      <p class="connections-label">Your API Endpoint connections</p>
      <button class="btn-new-endpoint" type="button" (click)="openNewEndpoint(); $event.stopPropagation()">
        New Endpoint
      </button>
    </div>

    <app-empty-state
      *ngIf="integrations.length === 0"
      [data]="emptyStateIntegrations">
    </app-empty-state>

    <div class="table-scroll-wrapper" *ngIf="integrations.length > 0">
    <table class="custom-table">
      <thead>
        <tr>
          <th>Display Name</th>
          <th>URL</th>
          <th>Authentication Type</th>
          <th>Created By</th>
          <th>Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let endpoint of pagedIntegrations">
          <td>{{ endpoint.displayName }}</td>
          <td>{{ endpoint.url }}</td>
          <td>{{ getAuthTypeDisplay(endpoint.authType) }}</td>
          <td>{{ endpoint.createdByEmail }}</td>
          <td>
            <div class="status-cell">
              <span [class]="isActive(endpoint.status) ? 'status-dot active' : 'status-dot inactive'"></span>
              {{ isActive(endpoint.status) ? 'Active' : 'Inactive' }}
            </div>
          </td>
          <td class="menu-cell" (click)="$event.stopPropagation()">
            <img
              src="../../assets/dotted-menu.svg"
              alt="menu"
              class="menu-trigger"
              (click)="toggleMenu(endpoint, $event)" />
          </td>
        </tr>
      </tbody>
    </table>
    </div>

    <!-- Pagination -->
    <div class="pagination" *ngIf="totalPages > 1">
      <button type="button" [style.opacity]="currentPage === 1 ? 0.5 : 1" (click)="performDecrement()">
        <img class="arrow flipped" src="../../assets/triangle-icon.svg" alt="previous" />
      </button>
      <button
        *ngFor="let page of visiblePages"
        class="page-number"
        [style]="currentPage === page ? selectedPage : ''"
        (click)="setCurrentPage(page)">
        {{ page }}
      </button>
      <button type="button" [style.opacity]="currentPage === totalPages ? 0.5 : 1" (click)="performIncrement()">
        <img class="arrow" src="../../assets/triangle-icon.svg" alt="next" />
      </button>
    </div>
  </div>

  <!-- Cloud Storage view -->
  <div [style.display]="integrationType === 'cloud' ? 'flex' : 'none'" class="cloud-placeholder">
    <p>Cloud storage integrations coming soon.</p>
  </div>

</main>

<!-- Row context menu — rendered outside the scroll wrapper so overflow-x:auto cannot clip it -->
<div
  *ngIf="showMenu && activeMenuEndpoint"
  class="custom-table__menu"
  [style.top.px]="menuPosition?.top"
  [style.right.px]="menuPosition?.right"
  (click)="$event.stopPropagation()">
  <div>{{ activeMenuEndpoint.displayName }}</div>
  <a (click)="openEditEndpoint(activeMenuEndpoint)">
    <img src="../../assets/edit-pencil.svg" alt="edit" />
    Edit Endpoint
  </a>
  <div (click)="toggleStatus(activeMenuEndpoint)">
    <img src="../../assets/delete.svg" alt="toggle status" />
    {{ isActive(activeMenuEndpoint.status) ? 'Deactivate' : 'Activate' }}
  </div>
</div>

<!-- Modal Overlay -->
<div class="modal-overlay" [style.display]="showModal ? 'flex' : 'none'" (click)="closeModal()">
  <div class="endpoint-modal" (click)="$event.stopPropagation()">

    <h2 class="modal-title">{{ isEditMode ? 'Edit Endpoint' : 'New API Endpoint' }}</h2>

    <!-- Display Name -->
    <div class="modal-field">
      <label class="custom-label">Display name <span class="field-required">*</span></label>
      <input
        class="custom-input"
        type="text"
        placeholder="Example"
        [(ngModel)]="form.displayName" />
    </div>

    <!-- Endpoint URL -->
    <div class="modal-field">
      <label class="custom-label">Endpoint URL <span class="field-required">*</span></label>
      <input
        class="custom-input"
        [class.input-error]="urlError"
        type="text"
        placeholder="https://api.example.com/example"
        [(ngModel)]="form.url"
        (blur)="validateUrl()"
        (input)="validateUrl()" />
      <p class="error-text" *ngIf="urlError">
        <img src="../../assets/Error.svg" alt="" style="width:14px;vertical-align:middle;margin-right:4px" />
        Enter a valid URL starting with http:// or https://
      </p>
    </div>

    <!-- Authentication Type -->
    <div class="modal-field">
      <label class="custom-label">Authentication Type <span class="field-required">*</span></label>
      <div class="select-wrapper">
        <select class="custom-select" [(ngModel)]="form.authType">
          <option *ngFor="let type of authTypes" [value]="type">{{ type }}</option>
        </select>
        <img src="../../assets/dropdown.svg" alt="" class="select-arrow" />
      </div>
    </div>

    <!-- API Key conditional fields -->
    <ng-container *ngIf="form.authType === 'API Key'">
      <div class="modal-field">
        <label class="custom-label">Header Name <span class="field-required">*</span></label>
        <input
          class="custom-input"
          type="text"
          placeholder="Header 1"
          [(ngModel)]="form.authHeaderName" />
      </div>
      <div class="modal-field">
        <label class="custom-label">Key Value <span class="field-required">*</span></label>
        <div class="secret-field-wrap">
          <input
            class="custom-input secret-input"
            [type]="showSecret ? 'text' : 'password'"
            [(ngModel)]="form.authSecret" />
          <button type="button" class="toggle-secret-btn" (click)="showSecret = !showSecret">
            <svg *ngIf="!showSecret" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8d9aa5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
            </svg>
            <svg *ngIf="showSecret" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8d9aa5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/>
            </svg>
          </button>
        </div>
        <p class="masked-hint">{{ isEditMode ? 'Leave blank to keep the existing value.' : 'After saving, this value will be permanently masked.' }}</p>
      </div>
    </ng-container>

    <!-- Bearer Token conditional fields -->
    <ng-container *ngIf="form.authType === 'Bearer Token'">
      <div class="modal-field">
        <label class="custom-label">Token Value <span class="field-required">*</span></label>
        <div class="secret-field-wrap">
          <input
            class="custom-input secret-input"
            [type]="showSecret ? 'text' : 'password'"
            [(ngModel)]="form.authSecret" />
          <button type="button" class="toggle-secret-btn" (click)="showSecret = !showSecret">
            <svg *ngIf="!showSecret" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8d9aa5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
            </svg>
            <svg *ngIf="showSecret" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8d9aa5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/>
            </svg>
          </button>
        </div>
        <p class="masked-hint">{{ isEditMode ? 'Leave blank to keep the existing value.' : 'After saving, this value will be permanently masked.' }}</p>
      </div>
    </ng-container>

    <!-- Additional Headers -->
    <div class="modal-field">
      <label class="custom-label">Additional Headers (optional, up to 5)</label>
      <div class="headers-col-labels" *ngIf="form.headers.length > 0">
        <span>Header Name</span>
        <span>Value</span>
      </div>
      <div class="header-row" *ngFor="let header of form.headers; let i = index">
        <input class="custom-input" type="text" placeholder="Header Name" [(ngModel)]="header.name" />
        <input class="custom-input" type="text" placeholder="Value" [(ngModel)]="header.value" />
        <button type="button" class="remove-header-btn" (click)="removeHeader(i)">&#10005;</button>
      </div>
      <button
        type="button"
        class="add-header-btn"
        *ngIf="form.headers.length < 5"
        (click)="addHeader()">
        + Add Header
      </button>
    </div>

    <!-- Test Connection -->
    <div class="modal-field test-section">
      <div class="test-connection-row">
        <label class="custom-label">Test Connection</label>
        <button
          type="button"
          class="btn-test"
          [disabled]="isTesting || urlError || !form.url.trim()"
          (click)="testConnection()">
          {{ isTesting ? 'Testing...' : 'Test' }}
        </button>
      </div>
      <p class="test-hint">Sends a sample payload, shows HTTP status and truncated response</p>
      <div class="test-result success" *ngIf="testResult?.success">
        <pre>{{ testResult?.message }}</pre>
      </div>
      <div class="test-result failure" *ngIf="testResult && !testResult.success">
        <pre>{{ testResult?.message }}</pre>
      </div>
    </div>

    <!-- Actions -->
    <div class="modal-actions">
      <button type="button" class="btn-outline" (click)="closeModal()">Cancel</button>
      <button
        type="button"
        class="btn-save-endpoint"
        [disabled]="!isFormValid()"
        (click)="saveEndpoint()">
        Save Endpoint
      </button>
    </div>

  </div>
</div>
